import Native from "./Native";
import { stringify } from "qs";

/** 短横线转驼峰 */
export function underlineToHump(str: string) {
  const strList = str.split("-");
  return strList
    .map(item => {
      item = item.slice(0, 1).toUpperCase() + item.slice(1);
      return item;
    })
    .join("");
}
/**
 * 日期格式化
 *   例如 dateFormat(new Date(), 'YYYY-mm-dd HH:MM')
 *
 * */
export function dateFormat(dateObj: Date, fmt: string) {
  var o = {
    "M+": dateObj.getMonth() + 1, //月份
    "d+": dateObj.getDate(), //日
    "h+": dateObj.getHours(), //小时
    "m+": dateObj.getMinutes(), //分
    "s+": dateObj.getSeconds(), //秒
    "q+": Math.floor((dateObj.getMonth() + 3) / 3), //季度
    S: dateObj.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (dateObj.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
}

/**
 * 修改后端返回富文本图片地址
 * @param html 处理的元素
 */
export function setImgSrc(html: Element) {
  const imgList = html.querySelectorAll("img");
  for (let index = 0; index < imgList.length; index++) {
    const element = imgList[index];
    if (element.getAttribute("data-original")) {
      element.src = element.getAttribute("data-original") + "";
    }
  }
  const videoList = html.querySelectorAll("video");
  for (let index = 0; index < videoList.length; index++) {
    const element = videoList[index];
    const source = element.getElementsByTagName("source");
    for (let si = 0; si < source.length; si++) {
      const se = source[si];
      if (se.getAttribute("data-original")) {
        se.src = se.getAttribute("data-original") + "";
      }
    }
    if (element.getAttribute("data-original")) {
      element.src = element.getAttribute("data-original") + "";
    }
  }

  const aList = html.querySelectorAll("a");
  for (let index = 0; index < aList.length; index++) {
    const element = aList[index];
    if (element.getAttribute("open-type") === "1") {
      element.onclick = () => {
        if (Native.isOpenInApp()) {
          if (Native.OpenSystemWeb) {
            Native.OpenSystemWeb(element.href);
          } else {
            location.href = element.href;
          }
        } else {
          location.href = element.href;
        }
        return false;
      };
    }
  }
}

export function os() {
  var ua = navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian;
  return {
    isTablet,
    isChrome,
    isPhone,
    isAndroid,
    isPc
  };
}

export function historyProjectHost(): string {
  let shareHost: string = "";
  if (
    process.env.VUE_APP_ENV == "development" ||
    process.env.VUE_APP_ENV == "testing"
  ) {
    // shareHost = "http://10.2.14.204:8080/";
    shareHost = "http://h5cloud.cqliving.com/zwytest/historians/";
  } else if (process.env.VUE_APP_ENV == "pre-release") {
    shareHost = "http://h5cloud.cqliving.com/zwyready/historians/";
  } else {
    shareHost = "http://h5cloud.cqliving.com/zwy/historians/";
  }
  return shareHost;
}
/**
 * 在js中使用px时调用此函数将设计稿px转换为当前rem适用的px
 * @param px px
 */
export function toRem(px: number) {
  const key = Math.round(window.innerWidth * 0.1333333333333333);
  return (px / 100) * key;
}

export function findNameByIdInApp(appInfo: any, id: number | string) {
  appInfo = appInfo ? appInfo : [];
  let name = "";
  appInfo.forEach((item: any) => {
    if (item.appId && item.appId == id) {
      name = item.appName;
    }
  });
  return name;
}

export function findNameByWechatAppid(appInfo: any, id: number | string) {
  appInfo = appInfo ? appInfo : [];
  let wechatAppid = "";
  appInfo.forEach((item: any) => {
    if (item.appId && item.appId == id) {
      wechatAppid = item.wechatAppid;
    }
  });
  return wechatAppid;
}
export function findNameByAppconfig(appInfo: any, id: number | string) {
  appInfo = appInfo ? appInfo : [];
  let wechatAppid: any;
  appInfo.forEach((item: any) => {
    if (item.appId && item.appId == id) {
      wechatAppid = item;
    }
  });
  return {
    appId: wechatAppid ? wechatAppid.appId : "",
    appName: wechatAppid ? wechatAppid.appName : "",
    wechatAppid: wechatAppid ? wechatAppid.wechatAppid : "",
    realmUrl: wechatAppid ? wechatAppid.realmUrl : "",
    wechatConfigId: wechatAppid ? wechatAppid.wechatConfigId : ""
  };
}

export function getAppidFromUA() {
  let ua = navigator.userAgent;
  let matchArr = /CQ_XHL\((.+)\)/.exec(ua);
  if (matchArr && matchArr.length) {
    let appinfoArr = matchArr[1].split(";");
    if (appinfoArr.length) {
      return appinfoArr[2];
    } else {
      return "";
    }
  } else {
    return "";
  }
}
